module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"timezone_hint":"Timezone {timezone}"},"zh":{"timezone_hint":"時區 {timezone}"}}')
  delete Component.options._Ctor
}
